import { Fragment, ReactNode } from 'react'

type LegalLink = {
  href?: string
  label: ReactNode
  element?: ReactNode
}

type Props = {
  message: string
  links: Record<string, LegalLink>
}

const LegalText = ({ message, links }: Props) => {
  const parts = message.split(/(\{\{\w+\}\})/g)

  return (
    <>
      {parts.map((part, index): ReactNode => {
        const key = part.match(/^\{\{(\w+)\}\}$/)?.[1]
        const link = key ? links[key] : undefined
        return link?.element ? (
          <Fragment key={index}>{link.element}</Fragment>
        ) : link?.href ? (
          <a
            key={index}
            target="_blank"
            rel="noreferrer"
            href={link.href}
            className="text-primary-600"
          >
            {link.label}
          </a>
        ) : (
          <Fragment key={index}>{link?.label ?? part}</Fragment>
        )
      })}
    </>
  )
}

export default LegalText
